import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptCustomDashboardsAPI from '../../api/wgpt/customDashboards';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  activeDashboard: {},
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getCustomDashboards($state) {
    return $state.records;
  },
  getCustomDashboard: $state => dashboardId => {
    const [dashboard] = $state.records.filter(
      record => record.id === Number(dashboardId)
    );
    return dashboard || {};
  },
  getActiveDashboard($state) {
    return $state.activeDashboard;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptCustomDashboardsAPI.get();
      commit(types.SET_WGPT_CUSTOM_DASHBOARDS, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isFetching: false });
    }
  },

  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await WgptCustomDashboardsAPI.show(id);
      commit(types.ADD_WGPT_CUSTOM_DASHBOARD, data);
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_ACTIVE, data);
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, {
        isFetchingItem: false,
      });
    }
  },

  create: async ({ commit }, dashboardObj) => {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptCustomDashboardsAPI.create(dashboardObj);
      commit(types.ADD_WGPT_CUSTOM_DASHBOARD, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isUpdating: true });
    try {
      const response = await WgptCustomDashboardsAPI.update(id, updateObj);
      commit(types.EDIT_WGPT_CUSTOM_DASHBOARD, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isDeleting: true });
    try {
      await WgptCustomDashboardsAPI.delete(id);
      commit(types.DELETE_WGPT_CUSTOM_DASHBOARD, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG, { isDeleting: false });
    }
  },

  setActiveDashboard({ commit }, dashboard) {
    commit(types.SET_WGPT_CUSTOM_DASHBOARD_ACTIVE, dashboard);
  },
};

export const mutations = {
  [types.SET_WGPT_CUSTOM_DASHBOARD_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_CUSTOM_DASHBOARDS]: MutationHelpers.set,
  [types.ADD_WGPT_CUSTOM_DASHBOARD]: MutationHelpers.setSingleRecord,
  [types.EDIT_WGPT_CUSTOM_DASHBOARD]: MutationHelpers.update,
  [types.DELETE_WGPT_CUSTOM_DASHBOARD]: MutationHelpers.destroy,
  [types.SET_WGPT_CUSTOM_DASHBOARD_ACTIVE]($state, data) {
    $state.activeDashboard = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
